import classNames from 'classnames'
import { ReactNode, useCallback } from 'react'

export interface CheckboxProps {
  value?: boolean
  name?: string
  onChange?: (val: boolean) => void | Promise<void>
  children?: ReactNode
}

export function Checkbox({
  value = false,
  name,
  onChange,
  children,
}: CheckboxProps) {
  const toggle = useCallback(() => {
    onChange?.(!value)
  }, [value, onChange])

  return (
    <label
      className='flex items-start justify-start space-x-2 text-base cursor-pointer h-fit'
      htmlFor={name}
    >
      <div className='relative z-0'>
        <input
          id={name}
          name={name}
          type='checkbox'
          value={value.toString()}
          onChange={toggle}
          checked={value}
          className={classNames(
            'relative w-5 h-5 shrink-0 appearance-none transition-all duration-200 ease-in-out cursor-pointer',
            'border rounded-[3px] outline-none ring-1 ring-transparent ring-offset-2 focus:ring-primary-600',
            'after:border-l-[3px] after:border-b-[3px]  after:w-[14px] after:h-[8px]',
            'after:absolute after:bottom-[6px] after:left-[2px] after:-rotate-45 after:z-[1]',
            {
              'after:border-background border-transparent bg-primary-500':
                value,
              'border-neutral-400 after:border-transparent bg-transparent':
                !value,
            }
          )}
        />
      </div>
      <span className='focus:ring-1 !text-left'>{children}</span>
    </label>
  )
}
